import { LightAlert } from 'components/shared/LightAlert';
import { FC, ReactNode } from 'react';
import type { AlertSeverity } from 'state/notifications/notification.model';

interface ErrorItemProps {
  children?: ReactNode;
  index: number;
  severity: AlertSeverity;
  htmlMessage: string;
}

export const ErrorItem: FC<ErrorItemProps> = ({ index, severity, htmlMessage, children }) => {
  return (
    <div className="d-flex flex-column mb-1 pb-1" key={`validation-error-${index}`}>
      <LightAlert key={index} severity={severity} e2e="validation-warning">
        <span dangerouslySetInnerHTML={{ __html: htmlMessage }} />
      </LightAlert>
      {children}
    </div>
  );
};
